import TR from 'utils/TR';
import Header from 'components/header';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import React from 'react';
import SimulationTabs from './SimulationTabs';
import useCategorizedPages from 'hooks/app/useCategorizedPages';
import PageOutlet from '../PageOutlet';

const category = 'Simulation';
export default function Simulation(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;
  const pages = useCategorizedPages(category);
  return (
    <VBox {...ex(['Page', 'Simulation'], rest)}>
      <SimulationTabs {...rest} {...{ category }} />
      <PageOutlet
        {...{
          renderAll,
          category,
          pages,
        }}
      />
    </VBox>
  );
}
